/* fd26 — "Complete your setup" behavior.
   Multi-item add-on add via /cart/add.js, then replicates Focal's cart-drawer event sequence.
   The base net is intentionally handled only by the main PDP Add to Cart button.
   Cart-400 safety: Liquid only renders toggles for AVAILABLE variants, and the net id is
   read live from the variant picker. Progressive enhancement: bundle tier is plain links,
   and any add failure surfaces an inline message instead of breaking the page. */
(function () {
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    var numeric = Number(number);

    if (Number.isNaN(numeric) || number == null) return '0';

    var fixed = (numeric / 100).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function plainText(html) {
    if (html.indexOf('<') === -1 && html.indexOf('&') === -1) return html;

    var div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || html.replace(/<[^>]*>/g, '');
  }

  function money(cents) {
    var settings = window.themeVariables && window.themeVariables.settings ? window.themeVariables.settings : {};
    var format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';
    var value;

    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return plainText(formatString.replace(placeholderRegex, value)).replace(/([$£€¥])\s+(?=\d)/g, '$1');
  }

  function salePrice(cents, saleActive, percent) {
    var price = Number(cents || 0);
    if (!saleActive) return price;

    return Math.round(price * (100 - percent) / 100);
  }

  function waitForCartDrawerReady(timeout) {
    if (!window.customElements || !window.customElements.whenDefined) {
      return Promise.resolve(false);
    }

    if (window.customElements.get('cart-drawer')) {
      return Promise.resolve(true);
    }

    return Promise.race([
      window.customElements.whenDefined('cart-drawer').then(function () {
        return true;
      }),
      new Promise(function (resolve) {
        window.setTimeout(function () {
          resolve(!!window.customElements.get('cart-drawer'));
        }, timeout || 1200);
      })
    ]);
  }

  function closeMiniCartFallback() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;

    drawer.removeAttribute('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lock-all');
  }

  function openMiniCartFallback(sectionHtml) {
    var drawer = document.getElementById('mini-cart');
    if (!drawer) return;

    if (sectionHtml) {
      var container = document.createElement('div');
      container.innerHTML = sectionHtml;
      var nextDrawer = container.querySelector('#mini-cart');

      if (nextDrawer) {
        drawer.innerHTML = nextDrawer.innerHTML;
      }
    }

    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lock-all');
  }

  function init(root) {
    if (root.dataset.fd26Init) return;
    root.dataset.fd26Init = '1';

    var netVid = root.dataset.netVariant || '';
    var netPrice = parseInt(root.dataset.netPrice, 10) || 0;
    var productFormId = root.dataset.productFormId || '';
    var saleActive = root.dataset.fd26SaleActive === '1';
    var salePercent = parseInt(root.dataset.fd26SalePercent, 10) || 15;
    var themeRoutes = window.themeVariables && window.themeVariables.routes ? window.themeVariables.routes : {};
    var themeSettings = window.themeVariables && window.themeVariables.settings ? window.themeVariables.settings : {};
    var cartAddUrl = root.dataset.cartAddUrl || themeRoutes.cartAddUrl || '/cart/add';
    var cartUrl = root.dataset.cartUrl || themeRoutes.cartUrl || '/cart';
    var cartType = root.dataset.cartType || themeSettings.cartType || 'drawer';
    var ctaText = root.dataset.ctaLabel || 'Add to cart';
    var addText = root.dataset.addLabel || 'Add';
    var addedText = root.dataset.addedLabel || 'Added';
    var emptySelectionError = root.dataset.emptySelectionError || 'Choose at least one add-on.';
    var genericError = root.dataset.genericError || 'Sorry, something went wrong adding to cart. Please try again.';
    var networkError = root.dataset.networkError || 'Network error. Please try again.';

    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-fd26-toggle]'));
    var cta = root.querySelector('[data-fd26-cta]');
    var ctaLabel = root.querySelector('[data-fd26-cta-label]');
    var errEl = root.querySelector('[data-fd26-err]');
    var offerSelector = root.querySelector('[data-mini-offer-selector]');
    var offerInputs = Array.prototype.slice.call(root.querySelectorAll('[data-mini-offer-option]'));
    var bundleStatus = root.querySelector('[data-fd26-bundle-status]');
    var productForm = productFormId ? document.getElementById(productFormId) : null;
    var productFormRoot = root.closest('.product-form');
    var productSection = root.closest('.cro-pdp');
    var mainCta = productForm ? productForm.querySelector('[data-mini-main-cta]') : null;
    var stickyForm = Array.prototype.slice.call(document.querySelectorAll('product-sticky-form')).find(function (element) {
      return element.getAttribute('form-id') === productFormId;
    });
    var stickyCta = stickyForm ? stickyForm.querySelector('[data-product-add-to-cart-button]') : null;
    var stickyTitle = stickyForm ? stickyForm.querySelector('.product-sticky-form__title') : null;
    var stickyPrice = stickyForm ? stickyForm.querySelector('.product-sticky-form__price') : null;
    var netOfferProperty = productForm ? productForm.querySelector('[data-mini-net-offer-property]') : null;
    var quantityInput = productForm ? productForm.querySelector('[name="quantity"]') : null;

    if (offerSelector && productSection) {
      document.documentElement.classList.add('nr-mini-pdp-active');
      document.body.classList.add('nr-mini-pdp-active');

      if (mainCta && stickyForm) {
        var miniDockRaf = 0;
        var footerSection = document.querySelector('.shopify-section--footer');

        function syncMiniDock() {
          miniDockRaf = 0;
          if (!window.matchMedia('(max-width: 767px)').matches) return;

          var ctaRect = mainCta.getBoundingClientRect();
          var headerSection = document.querySelector('.shopify-section--header');
          var headerBottom = headerSection ? headerSection.getBoundingClientRect().bottom : 0;
          var footerVisible = footerSection && footerSection.getBoundingClientRect().top < window.innerHeight;
          var ctaVisible = ctaRect.top < window.innerHeight && ctaRect.bottom > headerBottom;
          var ctaPassed = ctaRect.bottom <= headerBottom;

          productSection.classList.toggle('nr-mini-main-cta-visible', ctaVisible);
          stickyForm.hidden = !ctaPassed || footerVisible;
        }

        function scheduleMiniDockSync() {
          if (miniDockRaf) return;
          miniDockRaf = window.requestAnimationFrame(syncMiniDock);
        }

        window.addEventListener('scroll', scheduleMiniDockSync, { passive: true });
        window.addEventListener('resize', scheduleMiniDockSync);

        if ('IntersectionObserver' in window) {
          var miniDockObserver = new IntersectionObserver(scheduleMiniDockSync, { threshold: [0, 0.15, 1] });
          miniDockObserver.observe(mainCta);
          if (footerSection) miniDockObserver.observe(footerSection);
        }

        scheduleMiniDockSync();
        window.setTimeout(scheduleMiniDockSync, 300);
      }
    }

    function promotionEvent(eventName) {
      if (!offerSelector || !window.dataLayer || !Array.isArray(window.dataLayer)) return;

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: eventName,
        ecommerce: {
          items: [{
            promotion_id: offerSelector.dataset.miniBundleOfferId || 'mini-starter-69999',
            promotion_name: 'Mini Practice Bundle'
          }]
        }
      });
    }

    function loaderButtonText(button) {
      if (!button) return null;
      return button.querySelector('.loader-button__text') || button;
    }

    function setButtonLabel(button, label) {
      if (!button) return;
      button.setAttribute('data-button-content', label);
      var textElement = loaderButtonText(button);
      if (textElement) textElement.textContent = label;
    }

    function selectedOffer() {
      var checked = offerInputs.find(function (input) { return input.checked; });
      return checked ? checked.value : 'net';
    }

    function updateOfferState(trackSelection) {
      if (!offerSelector) return;

      var offer = selectedOffer();
      var isBundle = offer === 'bundle';
      var buttonLabel = isBundle ? 'Add all 3 to cart' : 'Add Mini net to cart';
      var offerPrice = parseInt(isBundle ? offerSelector.dataset.miniBundlePrice : offerSelector.dataset.miniNetPrice, 10) || 0;
      var stickyButtonLabel = isBundle ? 'Add bundle' : 'Add Mini';

      if (offerPrice) stickyButtonLabel += ' · ' + money(offerPrice);

      if (productFormRoot) productFormRoot.dataset.miniOfferState = offer;
      if (productSection) productSection.dataset.miniOfferState = offer;
      if (quantityInput && isBundle) quantityInput.value = '1';
      if (netOfferProperty) netOfferProperty.disabled = isBundle;

      setButtonLabel(mainCta, buttonLabel);
      setButtonLabel(stickyCta, stickyButtonLabel);

      if (stickyTitle) stickyTitle.textContent = isBundle ? '3-piece bundle' : 'Mini net';
      if (stickyPrice && offerPrice) stickyPrice.textContent = money(offerPrice);

      if (bundleStatus) {
        bundleStatus.textContent = '';
        bundleStatus.classList.remove('is-error');
      }

      if (trackSelection && isBundle) promotionEvent('select_promotion');
    }

    function selected() {
      return toggles.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; });
    }

    function recompute() {
      var sel = selected(), sum = 0;
      sel.forEach(function (t) { sum += parseInt(t.dataset.price, 10) || 0; });
      if (ctaLabel) ctaLabel.textContent = sel.length ? ctaText + ' - ' + money(sum) : ctaText;
      if (cta) {
        if (sel.length) {
          cta.removeAttribute('disabled');
        } else {
          cta.setAttribute('disabled', 'disabled');
        }
      }
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        var on = t.getAttribute('aria-pressed') === 'true';
        t.setAttribute('aria-pressed', on ? 'false' : 'true');
        t.classList.toggle('is-on', !on);
        var lbl = t.querySelector('[data-fd26-addtext]');
        if (lbl) lbl.textContent = on ? addText : addedText;
        recompute();
      });
    });

    document.addEventListener('variant:changed', function (e) {
      if (!e || !e.detail || !e.detail.variant) return;

      var sourceFormId = e.target && e.target.getAttribute ? e.target.getAttribute('id') : '';
      if (productFormId && sourceFormId !== productFormId) return;

      netVid = String(e.detail.variant.id);
      if (e.detail.variant.price != null) {
        netPrice = salePrice(e.detail.variant.price, saleActive, salePercent);
        recompute();
      }
      if (offerSelector) {
        window.setTimeout(function () { updateOfferState(false); }, 0);
      }
    });

    function announceCart(addJson) {
      if (productForm) {
        productForm.dispatchEvent(new CustomEvent('variant:added', {
          bubbles: true,
          detail: { variant: (addJson.items ? addJson.items[0] : addJson), responseJson: addJson }
        }));
      }
      fetch(cartUrl + '.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          return waitForCartDrawerReady(1400).then(function (cartDrawerReady) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            cart.sections = addJson.sections;
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cart, openMiniCart: cartType === 'drawer' }
            }));

            if (cartType !== 'drawer') return;

            window.setTimeout(function () {
              var drawer = document.getElementById('mini-cart');
              if (!drawer || drawer.hasAttribute('open')) return;

              if (cartDrawerReady && typeof drawer.open !== 'undefined') {
                drawer.open = true;
              } else {
                openMiniCartFallback(addJson.sections ? addJson.sections['mini-cart'] : '');
              }
            }, cartDrawerReady ? 900 : 80);
          });
        });
    }

    function addItems(items, triggers, statusEl, isBundle) {
      if (!items.length || !items[0].id) return;
      var triggerList = Array.isArray(triggers) ? triggers.filter(Boolean) : (triggers ? [triggers] : []);
      if (errEl) errEl.classList.remove('is-show');
      if (statusEl) {
        statusEl.textContent = '';
        statusEl.classList.remove('is-error');
      }
      triggerList.forEach(function (trigger) {
        trigger.setAttribute('disabled', 'disabled');
        trigger.setAttribute('aria-busy', 'true');
      });
      fetch(cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: 'mini-cart' })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          triggerList.forEach(function (trigger) {
            trigger.removeAttribute('disabled');
            trigger.removeAttribute('aria-busy');
          });
          if (res.ok) {
            if (statusEl) statusEl.textContent = 'All 3 items added. Bundle savings apply automatically in cart.';
            if (isBundle) promotionEvent('add_to_cart');
            announceCart(res.json);
          } else {
            var responseError = (res.json && res.json.description) ? res.json.description : genericError;
            if (statusEl) {
              statusEl.textContent = responseError;
              statusEl.classList.add('is-error');
            } else if (errEl) {
              errEl.textContent = responseError;
              errEl.classList.add('is-show');
            }
          }
        })
        .catch(function () {
          triggerList.forEach(function (trigger) {
            trigger.removeAttribute('disabled');
            trigger.removeAttribute('aria-busy');
          });
          if (statusEl) {
            statusEl.textContent = networkError;
            statusEl.classList.add('is-error');
          } else if (errEl) {
            errEl.textContent = networkError;
            errEl.classList.add('is-show');
          }
        });
    }

    if (offerSelector && productForm) {
      promotionEvent('view_promotion');
      var requestedOffer = new URL(window.location.href).searchParams.get('offer');
      if (requestedOffer === 'mini-practice-bundle') {
        var requestedBundleInput = offerInputs.find(function (input) { return input.value === 'bundle'; });
        if (requestedBundleInput) requestedBundleInput.checked = true;
      }

      offerInputs.forEach(function (input) {
        input.addEventListener('change', function () { updateOfferState(true); });
      });

      function submitSelectedBundle(event) {
        if (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        var offerId = offerSelector.dataset.miniBundleOfferId || 'mini-starter-69999';
        var bundleInstance = offerId + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
        var bundleIds = [
          parseInt(offerSelector.dataset.miniBundleNetVid || netVid, 10),
          parseInt(offerSelector.dataset.miniBundleBarriersVid, 10),
          parseInt(offerSelector.dataset.miniBundleMatVid, 10)
        ];
        var roles = ['net', 'barriers', 'mat'];

        if (bundleIds.some(function (id) { return !id; })) {
          if (bundleStatus) {
            bundleStatus.textContent = genericError;
            bundleStatus.classList.add('is-error');
          }
          return;
        }

        addItems(bundleIds.map(function (id, index) {
          return {
            id: id,
            quantity: 1,
            properties: {
              _bundle_offer: offerId,
              _bundle_instance: bundleInstance,
              _bundle_role: roles[index]
            }
          };
        }), [mainCta, stickyCta], bundleStatus, true);
      }

      productForm.addEventListener('submit', function (event) {
        if (selectedOffer() !== 'bundle') return;
        submitSelectedBundle(event);
      }, true);

      if (stickyCta) {
        stickyCta.addEventListener('click', function (event) {
          if (selectedOffer() !== 'bundle') return;
          submitSelectedBundle(event);
        }, true);
      }

      updateOfferState(requestedOffer === 'mini-practice-bundle');
    }

    if (cta) {
      cta.addEventListener('click', function () {
        var items = [];
        selected().forEach(function (t) { items.push({ id: parseInt(t.dataset.vid, 10), quantity: 1 }); });
        if (!items.length) {
          if (errEl) {
            errEl.textContent = emptySelectionError;
            errEl.classList.add('is-show');
          }
          return;
        }
        addItems(items, cta, null, false);
      });
    }

    recompute();
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;
    if (!event.target.closest('#mini-cart [data-action="close"], #mini-cart .drawer__overlay')) return;
    if (window.customElements && window.customElements.get && window.customElements.get('cart-drawer')) return;

    closeMiniCartFallback();
  });

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-fd26-cs]')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
